import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { INCIDENT_TYPE_API } from "./apiRoutes";

interface UseGetProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getIncidentTypeDropdown = async (communityId: string) =>
  await axiosAuth.get(`${INCIDENT_TYPE_API(communityId)}/dropdown`);

const useGetIncidentTypeDropdown = ({
  communityId,
  queryParams,
}: UseGetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["incident-type-dropdown", communityId],
    queryFn: () => getIncidentTypeDropdown(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetIncidentTypeDropdown;
